import { useState, useEffect } from "react";

const projects = [
  { url: "/images/portfolio/11349c93-448e-4dc8-9b0a-f3ffb0f3d00d.jpeg", category: "Residential" },
  { url: "/images/portfolio/1b750729-c589-49ad-bed6-f90d2f647f16.jpeg", category: "Residential" },
  { url: "/images/portfolio/2064eaaf-204f-4278-bfbb-b5476e87099e.jpeg", category: "Residential" },
  { url: "/images/portfolio/25e81786-b92a-4c64-82a5-7c1930645ea6.jpeg", category: "Residential" },
  { url: "/images/portfolio/2dfa72a9-c141-4db9-a9bc-0667c0136390.jpeg", category: "Residential" },
  { url: "/images/portfolio/46d1eb03-143d-455a-9faf-c2b0a83da9a2.jpeg", category: "Residential" },
  { url: "/images/portfolio/4a22f83b-5252-4b68-937c-e9378da5063b.jpeg", category: "Residential" },
  { url: "/images/portfolio/4cfb9493-389c-4673-ab8c-b6548cb5d93a.jpeg", category: "Residential" },
  { url: "/images/portfolio/7706ce4f-7db5-42ae-b576-c8626676051f.jpeg", category: "Residential" },
  { url: "/images/portfolio/787c64b0-38dc-47c4-a80f-839154826263.jpeg", category: "Interiors" },
  { url: "/images/portfolio/8467b606-d42c-4366-9d35-95752fcac9ef.jpeg", category: "Interiors" },
  { url: "/images/portfolio/b7074700-e924-4d37-b1ce-17b1bb355f5e.jpeg", category: "Interiors" },
  { url: "/images/portfolio/c1ba5438-2fb7-4ea3-9fcc-2c2a9b5c60e0.jpeg", category: "Interiors" },
  { url: "/images/portfolio/c1dce152-1d0c-4e88-b656-cddb64fb28a2.jpeg", category: "Interiors" },
  { url: "/images/portfolio/c25501e7-5bcb-42f2-b5d6-d4116d61ac20.jpeg", category: "Interiors" },
  { url: "/images/portfolio/c3baff16-cd4a-4195-a4fc-c4777bdefb93.jpeg", category: "Interiors" },
  { url: "/images/portfolio/d2b0bc6e-fd5a-47b9-b59a-98ea26e2c44a.jpeg", category: "Interiors" },
  { url: "/images/portfolio/f7f59f8e-7e26-487d-a5f0-cf46365bbb59.jpeg", category: "Interiors" },
  { url: "/images/portfolio/f85060ca-0213-438a-a6a2-2c902a64f853.jpeg", category: "Interiors" },
];

const filters = ["All", "Residential", "Interiors"];

export default function Portfolio() {
  const [active, setActive] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const filtered =
    active === "All" ? projects : projects.filter((p) => p.category === active);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-24 md:py-32 bg-[#1A1A1A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
          <div>
            <div className="w-12 h-[2px] bg-gold mb-6" />
            <h2
              data-testid="portfolio-heading"
              className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F9F9F7] tracking-[-0.02em]"
            >
              Our Work
            </h2>
            <p className="font-body text-base md:text-lg text-[#F9F9F7]/60 mt-4 max-w-lg font-light">
              A curated selection of projects that define our commitment to
              excellence.
            </p>
          </div>

          {/* Filters */}
          <div className="flex gap-2 flex-wrap" data-testid="portfolio-filters">
            {filters.map((f) => (
              <button
                key={f}
                data-testid={`filter-${f.toLowerCase()}`}
                onClick={() => setActive(f)}
                className={`font-body text-sm px-5 py-2 transition-all duration-300 ${active === f
                    ? "bg-gold text-charcoal"
                    : "bg-transparent border border-[#F9F9F7]/20 text-[#F9F9F7]/70 hover:border-gold hover:text-gold"
                  }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {filtered.map((project, i) => (
            <div
              key={project.url}
              data-testid={`portfolio-item-${i}`}
              className="relative overflow-hidden aspect-square bg-[#111111] cursor-pointer group"
              onClick={() => setSelectedImage(project.url)}
            >
              <img
                src={project.url}
                alt="Portfolio"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {/* Hover hint */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-white opacity-0 group-hover:opacity-80 transition-opacity duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          onClick={() => setSelectedImage(null)}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" />

          {/* Close button */}
          <button
            className="absolute top-6 right-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200"
            onClick={() => setSelectedImage(null)}
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* Full image */}
          <img
            src={selectedImage}
            alt="Portfolio Full View"
            className="relative z-10 max-w-[90vw] max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
